import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.black,
  paraColor: colors.black,
  subHeadingColor: colors.brightRed,
  bgColor: colors.white,
  ctaColor: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;